/* the phone's left drawer (assets/mobile.css); under 601px only, the overlay
   stands above */
(function () {
  'use strict';
  /* the line under each half is the client's to write (settings.half_*_line);
     the names are the record's own two words and are not settings */
  const DOORS = [
    { id: 'collective', name: 'collective', line: setting('half_collective_line', 'artists, and their work'), href: ROUTES.posts, pages: ['posts', 'post-event'] },
    { id: 'selective', name: 'selective', line: setting('half_selective_line', 'designers, and their work'), href: ROUTES.products, pages: ['list', 'item'] }
  ];
  /* the foot reads the legal register, so a policy renamed or added arrives
     here without anybody editing this file */
  function policies() {
    const reg = (window.SITE && window.SITE.legal) || [];
    return reg.map(function (lg) { return [lg.id, lg.name]; });
  }

  function rowHTML(d, page) {
    const on = d.pages.indexOf(page) >= 0;
    return '<a href="' + d.href + '"' + (on ? ' class="on" aria-current="page"' : '') + ' data-door="' + d.id + '">' +
      '<span class="dr-name">' + esc(d.name) +
      (d.line ? '<span class="u dr-line">' + esc(d.line) + '</span>' : '') + '</span></a>';
  }

  function html() {
    const page = document.body.dataset.page;
    const head = '<div class="dr-head">' +
        '<a class="u dr-brand" href="' + ROUTES.root + '">TURIYA</a>' +
        '<button class="u u-gray dr-close" type="button">close</button>' +
      '</div>';
    /* the header belongs to the list: an empty register takes the word with it
       rather than leaving a label over an empty nav */
    const reg = policies();
    const legal = reg.length
      ? '<span class="dr-foot-h">legal</span>' +
        '<nav class="dr-foot-legal" aria-label="policies">' +
        reg.map(function (sct) {
          return '<a class="u" href="' + (page === 'legal' ? '' : ROUTES.legal) + '#' + sct[0] + '">' + esc(sct[1]) + '</a>';
        }).join('') +
        '</nav>'
      : '';
    const foot = '<div class="dr-foot u u-gray">' +
        legal +
        '<span class="dr-foot-h dr-foot-h2">the space</span>' +
        '<span class="dr-foot-space">19 jandari-ro 3-gil, mapo-gu, seoul<br>thu to sun, 12 to 8</span>' +
        '<a class="u" href="' + esc(setting('instagram_url', '#')) + '" aria-label="instagram">instagram</a>' +
        /* lowercase on purpose: this block speaks the sheet's own voice, where
           every neighbour is lowercase */
        (document.body.dataset.cart
          ? '<a class="u dr-cart" href="' + (ROUTES.cart || '/cart') + '">cart ' +
            esc(document.body.dataset.cart) + '</a>'
          : '') +
      '</div>';
    const rows = '<nav class="dr-idx" aria-label="site">' +
      DOORS.map(function (d) { return rowHTML(d, page); }).join('') +
      '</nav>';
    return '<div class="dr-panel dr-panel-1">' + head + rows + foot + '</div>';
  }

  const drawer = document.createElement('aside');
  drawer.className = 'drawer';
  drawer.id = 'drawer';
  drawer.setAttribute('aria-label', 'menu');
  drawer.innerHTML = html();
  const scrim = document.createElement('div');
  scrim.className = 'drawer-scrim';
  document.body.appendChild(scrim);
  document.body.appendChild(drawer);

  const idx = drawer.querySelector('.dr-idx');
  const links = Array.prototype.slice.call(idx.querySelectorAll(':scope > a'));

  let isOpen = false, lockY = 0;
  function open(on) {
    isOpen = on;
    document.documentElement.classList.toggle('drawer-open', on);
    /* the iOS-safe lock: bare overflow:hidden let WebKit clip the flow away and
       jump the scroll on close, so the body is pinned at its offset instead */
    if (on) {
      lockY = window.scrollY;
      document.documentElement.classList.add('drawer-travel');
      document.documentElement.style.setProperty('--dr-lock', lockY + 'px');
      document.body.style.position = 'fixed';
      document.body.style.top = -lockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockY);
      /* the compensation stands until the push lands, or the header snaps at
         the release (the timer covers reduced motion, where nothing transitions) */
      const push = document.querySelector('.page-push');
      let released = false;
      const release = function () {
        if (released) return;
        released = true;
        document.documentElement.classList.remove('drawer-travel');
        document.documentElement.style.removeProperty('--dr-lock');
      };
      if (push) push.addEventListener('transitionend', function h(e) {
        if (e.target !== push) return;
        push.removeEventListener('transitionend', h);
        release();
      });
      setTimeout(release, 800);
    }
    if (on) {
      drawer.querySelector('.dr-close').focus({ preventScroll: true });
    }
  }
  idx.addEventListener('click', function (e) {
    const a = e.target.closest('a');
    if (!a) return;
    links.forEach(function (l) { l.classList.toggle('on', l === a); });
  });
  Array.prototype.forEach.call(drawer.querySelectorAll('.dr-close'), function (b) { b.addEventListener('click', function () { open(false); }); });
  /* a same-page policy link puts the page back before it jumps: with the lock
     standing the hash lands on a pinned body and nothing moves */
  drawer.addEventListener('click', function (e) {
    const a = e.target.closest('.dr-foot-legal a');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    e.preventDefault();
    open(false);
    requestAnimationFrame(function () { location.hash = href; });
  });
  scrim.addEventListener('click', function () { open(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) open(false); });

  /* the Menu corner is the drawer's on a phone: caught before assets/menu.js hears it */
  const btn = document.getElementById('menu-btn');
  if (btn) btn.addEventListener('click', function (e) {
    if (!isPhone()) return;
    e.stopImmediatePropagation();
    open(true);
  }, true);

  /* edge swipe in opens, any swipe left while open closes */
  let x0 = null, y0 = null, edge = false;
  document.addEventListener('touchstart', function (e) {
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; edge = x0 < 28;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (x0 === null || !isPhone()) return;
    const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = y0 = null;
    if (Math.abs(dy) > 50 || Math.abs(dx) < 60) return;
    if (dx > 0 && edge && !isOpen) open(true);
    else if (dx < 0 && isOpen) open(false);
  }, { passive: true });
})();
